const anetaMembership = `<!DOCTYPE html
PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
<title>You've started your Aneta membership!</title>
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<style>
  @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@500;600&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Proxima+Nova');
  body {
    width: 100% !important;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    margin: 0;
    padding: 0;
    line-height: 100%;
  }

  [style*="Quicksand"] {font-family: 'Quicksand', sans-serif !important;}

  img {
    outline: none;
    text-decoration: none;
    border:none;
    -ms-interpolation-mode: bicubic;
    max-width: 100%!important;
    margin: 0;
    padding: 0;
    display: block;
  }
  
  table td {
    border-collapse: collapse;
  }
  
  table {
    border-collapse: collapse;
    mso-table-lspace: 0pt;
    mso-table-rspace: 0pt;
  }
</style>
</head>

<body style="margin: 0; padding: 0;">
<table cellpadding="0" cellspacing="0" height="726" width="600" bgcolor="#ffffff" align="center" >
  <tr>
    <td style="padding: 35px; border-radius: 30px;">
      <table cellpadding="0" cellspacing="0" width="600">
        <tr>
          <td height="38" width="600"><img align="center" alt="logo" src="https://i.ibb.co/bN0fVK3/logo.png"></td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" style="margin-top: 8px; margin-bottom: 67px;">
        <tr>
          <td height="151" width="153" align="left"><img alt="robot" src="https://i.ibb.co/Jj1JVrf/robot.png" style="margin-right: 40px;"></td>
          <td height="62" width="250" align="left" style="color: #1B0C3D; font-size: 25px; font-weight: bold; font-family: 'Quicksand', sans-serif; line-height: 125%; font-style: normal;">
          <table>
            <tr>
              <td style="font-family: 'Quicksand', sans-serif;">You've started</td>
            </tr>
          </table>
          <table>
            <tr>
              <td style="font-family: 'Quicksand', sans-serif;">your Aneta membership!</td>
            </tr>
          </table>
          </td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600">
        <tr style="color: #1B0C3D; font-size: 12px; font-weight: bold; font-family: 'Quicksand', sans-serif;">
          <td>Welcome to Aneta!</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" style="margin-top: 20px;">
        <tr style="color: #8D869E; font-size: 12px; font-weight: 300; font-family: 'proxima-nova', sans-serif;">
          <td>You have signed up for your 30 day free trial of Aneta.</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="590" style="margin-top: 12px;">
        <tr style="color: #8D869E; font-size: 12px; font-weight: 300; font-family: 'proxima-nova', sans-serif;">
          <td>Your scholars can now navigate independently to productive and fun digital resources you approve of - even when you are not physically present.</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" style="margin-top: 12px;">
        <tr style="color: #8D869E; font-size: 12px; font-weight: 300; font-family: 'proxima-nova', sans-serif;">
          <td>If you did not create this account or wish to close your account for any reason, please contact us at</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" style="margin-bottom: 40px;">
        <tr>
          <td style="color: #00B5BA; font-size: 12px; font-weight: 400; font-family: 'proxima-nova', sans-serif;">support@anetaed.com</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600">
        <tr style="color: #8D869E; font-size: 12px; font-weight: 300; font-family: 'proxima-nova', sans-serif;">
          <td>We take online privacy seriously, especially when it comes to young scholars. To learn more about our commitment to privacy and data handling practices, please visit our website to read our full</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" style="margin-bottom: 40px;">
        <tr style="color: #00B5BA; font-size: 12px; font-weight: 300; font-family: 'proxima-nova', sans-serif;">
          <td><a href="https://anetaed.com/privacy.html" target="_blank" rel="noreferrer" style="color: #00B5BA; text-decoration: none; font-weight: 500;">Terms of Use and Privacy Policy.</a></td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" style="margin-bottom: 4px;">
        <tr style="color: #1B0C3D; font-size: 12px; font-weight: bold; font-family: 'Quicksand', sans-serif;">
          <td>Warm regards,</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" height="48" style="padding-bottom: 17px; border-bottom: 1px solid #E8E7EC;">
        <tr style="color: #1B0C3D; font-size: 25px; font-weight: bold; font-family: 'Quicksand', sans-serif;">
          <td>The Aneta Team</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" style="margin-bottom: 4px; margin-top: 8px;">
        <tr style="color: #8D869E; font-size: 8px; font-weight: 300; font-family: 'proxima-nova', sans-serif;">
          <td>This email was sent to you as part of your AnetaEd.com subscription. <a href="https://app.anetaed.com/dashboard/scholars" target="_blank" rel="noreferrer" style="color: #00B5BA; text-decoration: none;">Click here</a> to view your family dashboard and modify your settings.</td>
        </tr>
      </table>
      <table cellpadding="0" cellspacing="0" width="600" style="margin-bottom: 4px;">
        <tr style="color: #8D869E; font-size: 10px; font-weight: bold; font-family: 'proxima-nova', sans-serif;">
          <td>Anetaed.com, Inc. | <a href="https://anetaed.com" target="_blank" rel="noreferrer" style="color: #00B5BA; text-decoration: none;">https://anetaed.com</a></td>
        </tr>
      </table>
    </td>
  </tr>
</table>
</body>

</html>`;

export default anetaMembership;
